import { StorableObject } from "@app/core/storable-object";

export class CourseLogo extends StorableObject {
  public id: string;
  public courseCode: string;
  public courseLogoType: number;
  public fileType: string;
  public fileBase64: string;
  public fileBytes: Array<number> = new Array<number>();
}